/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Users_Invite_Confirm_TitleInputs */

const cs_users_invite_confirm_title = /** @type {(inputs: Users_Invite_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Poslat pozvánku (${i?.count})?`)
};

const en_users_invite_confirm_title = /** @type {(inputs: Users_Invite_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send invitation (${i?.count})?`)
};

/**
* | output |
* | --- |
* | "Send invitation ({count})?" |
*
* @param {Users_Invite_Confirm_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_invite_confirm_title = /** @type {((inputs: Users_Invite_Confirm_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Invite_Confirm_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_invite_confirm_title(inputs)
	return cs_users_invite_confirm_title(inputs)
});